<h2 mat-dialog-title>{{ data?.title }}</h2>

<div mat-dialog-content>
  @for (question of data.questions; track trackByQuestionId($index, question)) {
  <div [ngClass]="'question-' + question.type">
    <!-- Only show if question is visible -->
    @if (isQuestionVisible(question)) {
    <div>
      <!-- Question Label -->
      @if (question.label && question.type !== 'confirm' && question.type !== 'follow-up-interval') {
      <label class="question-label">
        {{ question.label }}
        @if (question.required) {
        <span class="required-asterisk"> *</span>
        }
      </label>
      }
      <!-- Confirm Question (checkbox acknowledgement) -->
      @if (question.type === 'confirm') {
      <mat-checkbox [checked]="getAnswer(question.id) === true"
        (change)="onAnswerChange(question.id, $event.checked)">
        {{ question.label }}
        @if (question.required) {
        <span class="required-asterisk"> *</span>
        }
      </mat-checkbox>
      }
      <!-- Dropdown Question -->
      @if (question.type === 'dropdown') {
      <mat-form-field class="full-width" appearance="outline">
        <mat-select
          [placeholder]="question.placeholder || 'Select an option'"
          [value]="getAnswer(question.id)"
          (selectionChange)="onAnswerChange(question.id, $event.value)"
          (openedChange)="onDropdownOpenedChange(question.id, $event)"
        >
          @for (option of getDropdownOptions(question); track option) {
          <mat-option [value]="option.value" [id]="getOptionId(question.id, option.value)">
            {{ getDisplayLabel(question, option.value) }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
      <!-- Clinician Select Question -->
      @if (question.type === 'clinician-select') { @if (question.allClinicians?.length) {
      <mat-checkbox [(ngModel)]="selectFromAllClinicians" class="mm-mb-2">
        Select from all clinicians:
      </mat-checkbox>
      }
      <app-clinician-select
        [clinicians]="getClinicianOptions(question)"
        [showUnassignOverride]="false"
        [bypassAdminCheck]="true"
        [fullWidth]="true"
        [hideStats]="selectFromAllClinicians"
        [label]="question.label"
        (clinicianChange)="onClinicianSelectChange(question.id, $event)"
      >
      </app-clinician-select>
      }
      <!-- Follow-up interval (same picker as the Programs schedule dialog) -->
      @if (question.type === 'follow-up-interval') {
      @let ctx = getIntervalContext(question);
      <app-follow-up-interval-picker
        [value]="getAnswer(question.id)"
        [defaultDays]="ctx?.defaultDays ?? null"
        [defaultLabelPrefix]="ctx?.defaultLabelPrefix ?? 'Plan default'"
        [cycleStart]="ctx?.cycleStart ?? null"
        [leadDays]="ctx?.leadDays ?? null"
        (valueChange)="onAnswerChange(question.id, $event)"
      ></app-follow-up-interval-picker>
      }
      <!-- Number Question -->
      @if (question.type === 'number') {
      <mat-form-field class="full-width" appearance="outline">
        <input
          matInput
          type="number"
          [min]="question.min"
          [max]="question.max"
          [placeholder]="question.placeholder || ''"
          [value]="getAnswer(question.id) ?? ''"
          (input)="onAnswerChange(question.id, $any($event.target).value ? +$any($event.target).value : '')"
        >
      </mat-form-field>
      }
      <!-- Textarea Question -->
      @if (question.type === 'textarea') {
      <mat-form-field class="full-width" appearance="outline">
        <textarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="12"
          [placeholder]="question.placeholder || 'Enter your response'"
          [value]="getAnswer(question.id) || ''"
          (input)="onAnswerChange(question.id, $any($event.target).value)"
          style="resize: vertical"
        >
        </textarea>
      </mat-form-field>
      }
      <!-- Warning note shown below input -->
      @if (question.note) {
      <app-alert-box
        type="error"
        [message]="question.note"
        [dismissible]="false"
        [isVisible]="true"
      >
      </app-alert-box>
      }
      <!-- Multi-select Question -->
      @if (question.type === 'multi-select') {
      <div>
        <app-tags-autocomplete
          [tags]="data.tags || []"
          [config]="{
            label: question.label,
            placeholder: question.placeholder,
            appearance: 'outline',
            addTagText: 'Add New',
            addTag: true,
            selectable: true,
            removable: true
          }"
          (change)="onMultiSelectChange(question.id, $event)"
        >
        </app-tags-autocomplete>
      </div>
      }
    </div>
    }
  </div>
  }
</div>

<!-- Alert Box for dynamic messages -->
@if (isAlertVisible) {
<app-alert-box
  [type]="alertType"
  [message]="alertMessage"
  [dismissible]="false"
  [isVisible]="isAlertVisible"
  (dismiss)="onAlertDismiss()"
>
</app-alert-box>
}

<div mat-dialog-actions align="end">
  <button mat-flat-button class="mm-bg-pink mm-text-white" (click)="dialogRef.close()">
    Cancel
  </button>
  <button
    mat-flat-button
    class="mm-bg-primary mm-text-white"
    [disabled]="!canSubmit()"
    (click)="closeDialog()"
  >
    Submit
  </button>
</div>
